import {capitalize} from 'lodash/string';
import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * invitation endpoints
 */
export const fetchInvitations = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/invitations', q, page, perPage, sortOpts, extraParams);

export const fetchInvitation = (invitationId) => request.fetchDetail(`/invitations/${invitationId}`);

export const createInvitation = (payload) =>
  request.postJSON(
    '/invitations',
    excludeObjNullValue({
      origin: window.location.origin,
      username: payload.username,
      first_name: capitalize(payload.firstName),
      last_name: capitalize(payload.lastName),
      email: payload.email,
      role: payload.role,
      school_id: payload.schoolId,
      classroom_id: payload.classroomId,
      parent_id: payload.parentId,
    }),
  );

export const updateInvitation = (payload) =>
  request.putJSON(
    `/invitations/${payload.invitationId}`,
    excludeObjNullValue({
      origin: window.location.origin,
      username: payload.username,
      first_name: capitalize(payload.firstName),
      last_name: capitalize(payload.lastName),
      email: payload.email,
      role: payload.role,
      school_id: payload.schoolId,
      classroom_id: payload.classroomId,
      parent_id: payload.parentId,
    }),
  );

export const deleteInvitation = (invitationId) => request.deleteReq(`/invitations/${invitationId}`);

export const validateInvitation = () => request.getJSON(`/invitation/validate${window.location.search}`);

export const schoolBulkInvite = (payload) =>
  request.postJSON(
    '/invitations/school_bulk_invite',
    excludeObjNullValue({
      origin: window.location.origin,
      role: payload.role,
      users: payload.users.map((user) => ({
        email: user.email,
      })),
    }),
    {
      school_id: payload.schoolId,
    },
  );

export const classroomBulkInvite = (payload) =>
  request.postJSON(
    '/invitations/classroom_bulk_invite',
    excludeObjNullValue({
      origin: window.location.origin,
      role: payload.role,
      users: payload.users.map((user) => ({
        email: user.email,
      })),
    }),
    {
      classroom_id: payload.classroomId,
    },
  );

export const resendInvitation = (invitationId) =>
  request.putJSON(
    `/invitations/${invitationId}/resend`,
    excludeObjNullValue({
      origin: window.location.origin,
    }),
  );
